import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const ConfirmEntryDialog = ({
  open, onOpenChange, dialogKey, confirmForm, setConfirmForm, sale, horse, saving, onConfirm, dateInputRef, creditsRemaining
}) => (
  <Dialog key={dialogKey} open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-2xl">
      <DialogHeader>
        <DialogTitle>Confirm Sale Entry</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Sale</Label>
            <Input value={sale?.sale_name || ''} disabled className="bg-muted" />
          </div>
          <div className="space-y-2">
            <Label>Horse</Label>
            <Input value={horse?.system_name || horse?.name || ''} disabled className="bg-muted" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Date Confirmed *</Label>
            <Input
              type="date"
              ref={dateInputRef}
              value={confirmForm.date_entered}
              onChange={(e) => setConfirmForm({...confirmForm, date_entered: e.target.value})}
            />
          </div>
          <div className="space-y-2">
            <Label>Entry Status</Label>
            <Select value="confirmed" onValueChange={() => {}}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="confirmed">Confirmed</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>

        <div className={`p-4 border rounded ${creditsRemaining > 0 ? 'bg-amber-50 border-amber-200' : 'bg-red-50 border-red-200'}`}>
          {creditsRemaining > 0 ? (
            <>
              <p className="text-sm text-amber-900 font-medium">Billing Notice</p>
              <p className="text-sm text-amber-700 mt-1">
                Confirming this sale entry will advance the opportunity to "Confirmed Sale Entry" stage. 1 sale entry credit will be used. You have <strong>{creditsRemaining}</strong> credit{creditsRemaining !== 1 ? 's' : ''} remaining.
              </p>
            </>
          ) : (
            <>
              <p className="text-sm text-red-900 font-medium">No Credits Available</p>
              <p className="text-sm text-red-700 mt-1">
                You have no sale entry credits remaining. Please purchase a credit pack from the <strong>Manage Plan</strong> page before confirming this entry.
              </p>
            </>
          )}
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onConfirm} disabled={saving || creditsRemaining <= 0} className="bg-primary hover:bg-primary/90 text-white">
          {saving ? 'Confirming...' : 'Review & Confirm'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const ChargeConfirmDialog = ({ open, onOpenChange, saving, onProceed }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Confirm Entry Fee</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        <p className="text-sm text-muted-foreground mb-4">
          Once you proceed to the next presale stage, you will be charged for an entry.
        </p>
        <p className="text-sm font-medium">Please confirm you would like to proceed.</p>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onProceed} disabled={saving} className="bg-primary hover:bg-primary/90 text-white">
          {saving ? 'Processing...' : 'Confirm & Proceed'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const DeleteConfirmDialog = ({ open, onOpenChange, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Delete Sale Opportunity</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        <p className="text-sm text-muted-foreground mb-2">Are you sure you want to delete this sale opportunity?</p>
        <p className="text-sm font-medium text-red-600">This action cannot be undone.</p>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onConfirm} variant="destructive">Delete Opportunity</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const ArchiveConfirmDialog = ({ open, onOpenChange, onArchive }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Archive Sale Opportunity</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        <p className="text-sm text-muted-foreground mb-2">Archive this sale opportunity? It will be moved to Historic Sales.</p>
        <p className="text-sm text-muted-foreground">You can access archived opportunities from the &quot;View Historic Sales&quot; button.</p>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onArchive} className="bg-blue-600 hover:bg-blue-700 text-white">Archive Opportunity</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
